import { FunctionComponent } from 'react';
import DOMPurify from 'dompurify';
import { styled } from 'styled-components';
import { paletteHelper, spacingHelper, typographyHelper, Text } from '@property.com.au/ui-kit';
import { usePropertyPageQuery } from '../../../../../graphql/usePropertyPageQuery';
import archistarLogoSvg from '../.././../../../../assets/archistar-logo.svg';
import archistarSvg from '../.././../../../../assets/archistar.svg';

const Wrapper = styled.div`
  p {
    color: ${paletteHelper('textSecondary')};
    ${typographyHelper('body01')};
  }

  p.title {
    ${typographyHelper('body01Bold')};
  }

  a {
    color: ${paletteHelper('linkPrimary')};
  }
`;

const Archistar = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacingHelper('twoExtraSmall')};
  margin-top: ${spacingHelper('extraSmall')};
`;

export const GovernmentOverlaysBrickDataDisclaimerModalContentWithData: FunctionComponent = () => {
  const propertyPage = usePropertyPageQuery()?.data.propertyPageBySlugV3;
  if (!propertyPage?.governmentDataV3?.dataDisclaimers) return null;

  const { geoscapeDisclaimerHtml, archistarDisclaimerHtml } =
    propertyPage.governmentDataV3.dataDisclaimers;

  return (
    <GovernmentOverlaysBrickDataDisclaimerModalContent
      geoscapeDisclaimerHtml={geoscapeDisclaimerHtml ?? null}
      archistarDisclaimerHtml={archistarDisclaimerHtml ?? null}
    />
  );
};

interface GovernmentOverlaysBrickDataDisclaimerModalContentProps {
  geoscapeDisclaimerHtml: string | null;
  archistarDisclaimerHtml: string | null;
}

export const GovernmentOverlaysBrickDataDisclaimerModalContent: FunctionComponent<
  GovernmentOverlaysBrickDataDisclaimerModalContentProps
> = ({ geoscapeDisclaimerHtml, archistarDisclaimerHtml }) => (
  <Wrapper>
    <Text>
      This information below has been aggregated from third party data sources and may contain
      inaccuracies. You should always consult the relevant government body or original source to
      verify information before relying on it.
    </Text>
    <br />
    <Text className="title">Geoscape data</Text>
    {geoscapeDisclaimerHtml && (
      <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(geoscapeDisclaimerHtml) }} />
    )}
    <br />
    {archistarDisclaimerHtml && (
      <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(archistarDisclaimerHtml) }} />
    )}
    <Archistar>
      <img alt="Archistar logo" width="24" height="24" src={archistarLogoSvg} />
      <img alt="Archistar" src={archistarSvg} />
    </Archistar>
  </Wrapper>
);
